import { Stack, Typography } from "@mui/material";
import React from "react";
import { allIcons } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";
import DynamicTable from "../../../components/DynamicTable";
import appcolors from "../../../constants/Colors";
import AppContainer from "./../../../components/AppContainer/index";
import { useSelector } from "react-redux";

const headerData = [
  "Created at",
  "Branch Name",
  "Address",
  "Sale",
  "Profit",
  "Actions",
];

const tableRows = [
  "date_time",
  "branch_name",
  "branch_address",
  "branch_sale",
  "branch_profit",
  "actions",
];

const AllBranches = ({
  allBranches,
  handleEdit,
  handleChangeTab,
  handleDeleteBranch,
  setType,
}) => {
  const { user } = useSelector((state) => state.user);

  const renderRightPart = () => {
    return (
      <Stack
        gap={1}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <GlobalButton
          variant={"contained"}
          btnText={"Add New"}
          handleClickBtn={() => {
            setType("add");
            handleChangeTab("addEditBranch");
          }}
          styleProps={{
            fontWeight: 400,
            fontSize: "0.875rem",
            height: 40,
            width: 130,
          }}
        />
      </Stack>
    );
  };

  return (
    <AppContainer
      primaryHeading={"Branches"}
      secondaryHeading={"You can add and remove all branches"}
      headProps={user?.role == "business" && renderRightPart()}
      customIcom={<img src={allIcons.branchInactiveIcon} width={25} />}
    >
      {allBranches?.length > 0 ? (
        <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allBranches}
          showDelete={false}
          showEdit={true}
          handleEdit={handleEdit}
          handleDelete={handleDeleteBranch}
        />
      ) : (
        <Typography
          variant="h1"
          fontSize={23}
          textAlign={"center"}
          color={appcolors.black}
          mt={20}
          mb={20}
        >
          No Branch Found!
        </Typography>
      )}
    </AppContainer>
  );
};

export default AllBranches;
